import { Button } from '@/components/Elements';
import { Heading } from '@/components/Elements/Heading';
import { showNotification } from '@/utils/notificationUtils';
import { title } from 'process';
import React, { useEffect, useState } from 'react';
import { Modal } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';

type FormHeadingProps = {
  heading: string;
  description: string;
  onUpdate: (formHeading: string, formDescription: string) => void;
  onClose: () => void;
  show: boolean;
};
const FormHeadingDialog = ({ heading, description, show, onUpdate, onClose }: FormHeadingProps) => {
  const [formHeading, setFormHeading] = useState<string>('');
  const { t, i18n } = useTranslation();
  const [formDescription, setFormDescription] = useState<string>('');
  useEffect(() => {
    setFormHeading(heading);
    setFormDescription(description);
  }, []);

  const handleInputChange = (event: any, key: string) => {
    if (event.target.id === 'form-heading') {
      setFormHeading(event.target.value);
    } else if (event.target.id === 'form-description') {
      setFormDescription(event.target.value);
    }
  };
  const updateFormFields = () => {
    if (!formHeading || formHeading === '') {
      showNotification({
        type: 'error',
        title: 'Please enter form heading',
      });
      return;
    }
    // if (!formDescription || formDescription === '') {
    //   showNotification({
    //     type: 'error',
    //     title: 'Please enter form heading',
    //   });
    // }
    onUpdate(formHeading, formDescription);
  };
  return (
    <Modal
      show={show}
      onHide={() => onClose()}
      className="petsked-modal-dialog  form-heading-dialog"
    >
      <Modal.Header closeButton>
        <Heading size="lg" title={t(`Edit Form Heading`)} />
      </Modal.Header>

      <Modal.Body>
        <div className="form-field-create-form">
          <div className="petsked-form">
            <label className="form-label my-3">{t('Form Heading')}</label>
            <div className="form-field">
              <input
                id="form-heading"
                className="mb-3"
                type="text"
                placeholder={t("Enter form heading")}
                maxLength={50}
                onChange={(e) => handleInputChange(e, 'fieldLabel')}
                value={formHeading}
              />
            </div>
            <label className="form-label my-2">{t('Form Description')}</label>
            <div className="form-field">
              <textarea
                id="form-description"
                className="mb-3"
                placeholder={t("Enter form description")}
                maxLength={150}
                onChange={(e) => handleInputChange(e, 'fieldName')}
                value={formDescription}
              />
            </div>
          </div>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="primary" size="lg" onClick={updateFormFields}>
          {t('Update')}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default FormHeadingDialog;
